import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  es: {
    translation: {
      app: { name: "iDiag", tagline: "Diagnóstico iPhone" },
      nav: {
        install: "Instalar app",
        installed: "App instalada",
        language: "Idioma",
        history: "Historial",
      },
      hero: {
        title: "Diagnostica tu iPhone en segundos",
        subtitle:
          "Sube un archivo panic log (.ips) y nuestra IA nivel experto identificará la pieza defectuosa, con análisis técnico profundo y pasos de reparación.",
        badge: "Análisis IA · Apple .ips",
      },
      gate: {
        title: "Antes de empezar",
        subtitle: "Indícanos tu nombre para continuar.",
        label: "Tu nombre",
        placeholder: "Escribe tu nombre",
        start: "Comenzar el diagnóstico",
        greeting: "Hola",
        change: "Cambiar",
      },
      uploader: {
        drop: "Arrastra tu archivo .ips aquí",
        or: "o",
        browse: "Seleccionar archivo",
        formats: "Formatos: .ips, .panic, .synapse, .crash, .log, .txt — máx. 50 MB",
        analyzing: "Analizando panic log…",
        analyzingHint: "La IA está examinando el panic string, kernel, SoC y cadena de componentes.",
        analyzingLong: "Esto puede tomar entre 20 y 60 segundos.",
        errorTooBig: "Archivo demasiado grande (máx. 50 MB).",
        errorEmpty: "El archivo está vacío.",
        errorGeneric: "No se pudo analizar el archivo.",
        offline: "Sin conexión. El diagnóstico requiere internet.",
        invalidType: "Tipo de archivo no soportado.",
      },
      result: {
        title: "Diagnóstico",
        device: "Dispositivo",
        cpu: "CPU",
        ios: "iOS",
        panicTag: "Etiqueta del panic",
        panicType: "Tipo de panic",
        shortDescription: "Descripción",
        primary: "Pieza principal defectuosa",
        involved: "Componentes implicados",
        confidence: "Confianza",
        technicalAnalysis: "Análisis técnico",
        repairSteps: "Pasos de reparación",
        stepObjective: "Objetivo",
        stepCommonFaults: "Fallas comunes",
        stepProcedures: "Procedimientos",
        stepExpected: "Resultados esperados",
        replacementOrder: "Orden recomendado de sustitución",
        postRepair: "Procedimientos post-reparación",
        conclusion: "Conclusión técnica",
        severity: "Severidad",
        severityLow: "Baja",
        severityMedium: "Media",
        severityHigh: "Alta",
        severityCritical: "Crítica",
        new: "Nuevo diagnóstico",
        share: "Compartir",
        exportPdf: "Exportar PDF",
        exporting: "Generando PDF…",
        copied: "Copiado al portapapeles",
        savedAt: "Guardado el",
      },
      history: {
        title: "Historial de diagnósticos",
        subtitle: "Los 50 análisis más recientes.",
        empty: "Aún no hay diagnósticos.",
        backHome: "Volver al inicio",
        loading: "Cargando…",
        notFound: "Diagnóstico no encontrado.",
      },
      footer: {
        rights: "Todos los derechos reservados.",
      },
      reviews: {
        button: "Deja tu opinión",
        title: "Deja tu opinión",
        subtitle: "Cuéntanos tu experiencia con iDiag.",
        rating: "Tu valoración",
        name: "Tu nombre (opcional)",
        comment: "Tu comentario",
        commentPlaceholder: "Escribe tu opinión…",
        addPhoto: "Añadir una foto",
        changePhoto: "Cambiar foto",
        submit: "Enviar opinión",
        submitting: "Enviando…",
        success: "¡Gracias por tu opinión!",
        error: "No se pudo enviar tu opinión.",
        ratingRequired: "Selecciona una valoración.",
        commentRequired: "Escribe un comentario.",
        recent: "Opiniones recientes",
        empty: "Aún no hay opiniones. ¡Sé el primero!",
        anonymous: "Anónimo",
      },
      pdf: {
        generatedBy: "Generado por iDiag",
        generatedOn: "Generado el",
        page: "Página",
      },
    },
  },
  fr: {
    translation: {
      app: { name: "iDiag", tagline: "Diagnostic iPhone" },
      nav: {
        install: "Installer l'app",
        installed: "App installée",
        language: "Langue",
        history: "Historique",
      },
      hero: {
        title: "Diagnostiquez votre iPhone en quelques secondes",
        subtitle:
          "Téléversez un fichier panic log (.ips) et notre IA niveau expert identifie la pièce défectueuse, avec analyse technique approfondie et étapes de réparation.",
        badge: "Analyse IA · Apple .ips",
      },
      gate: {
        title: "Avant de commencer",
        subtitle: "Indiquez votre prénom pour continuer.",
        label: "Votre prénom",
        placeholder: "Entrez votre prénom",
        start: "Commencer le diagnostic",
        greeting: "Bonjour",
        change: "Changer",
      },
      uploader: {
        drop: "Glissez votre fichier .ips ici",
        or: "ou",
        browse: "Sélectionner un fichier",
        formats: "Formats : .ips, .panic, .synapse, .crash, .log, .txt — max. 50 Mo",
        analyzing: "Analyse du panic log…",
        analyzingHint: "L'IA examine le panic string, le kernel, le SoC et la chaîne de composants.",
        analyzingLong: "Cela peut prendre entre 20 et 60 secondes.",
        errorTooBig: "Fichier trop volumineux (max. 50 Mo).",
        errorEmpty: "Le fichier est vide.",
        errorGeneric: "Impossible d'analyser le fichier.",
        offline: "Hors-ligne. Le diagnostic nécessite Internet.",
        invalidType: "Type de fichier non supporté.",
      },
      result: {
        title: "Diagnostic",
        device: "Appareil",
        cpu: "CPU",
        ios: "iOS",
        panicTag: "Étiquette du panic",
        panicType: "Type de panic",
        shortDescription: "Description",
        primary: "Pièce principale défectueuse",
        involved: "Composants impliqués",
        confidence: "Confiance",
        technicalAnalysis: "Analyse technique",
        repairSteps: "Étapes de réparation",
        stepObjective: "Objectif",
        stepCommonFaults: "Pannes fréquentes",
        stepProcedures: "Procédures",
        stepExpected: "Résultats attendus",
        replacementOrder: "Ordre de remplacement recommandé",
        postRepair: "Procédures post-réparation",
        conclusion: "Conclusion technique",
        severity: "Sévérité",
        severityLow: "Faible",
        severityMedium: "Moyenne",
        severityHigh: "Élevée",
        severityCritical: "Critique",
        new: "Nouveau diagnostic",
        share: "Partager",
        exportPdf: "Exporter en PDF",
        exporting: "Génération du PDF…",
        copied: "Copié dans le presse-papier",
        savedAt: "Enregistré le",
      },
      history: {
        title: "Historique des diagnostics",
        subtitle: "Les 50 analyses les plus récentes.",
        empty: "Aucun diagnostic pour le moment.",
        backHome: "Retour à l'accueil",
        loading: "Chargement…",
        notFound: "Diagnostic introuvable.",
      },
      footer: {
        rights: "Tous droits réservés.",
      },
      reviews: {
        button: "Laisse ton commentaire",
        title: "Laisse ton commentaire",
        subtitle: "Partage ton expérience avec iDiag.",
        rating: "Ta note",
        name: "Ton nom (optionnel)",
        comment: "Ton commentaire",
        commentPlaceholder: "Écris ton avis…",
        addPhoto: "Ajouter une photo",
        changePhoto: "Changer la photo",
        submit: "Envoyer l'avis",
        submitting: "Envoi…",
        success: "Merci pour ton avis !",
        error: "Impossible d'envoyer ton avis.",
        ratingRequired: "Sélectionne une note.",
        commentRequired: "Écris un commentaire.",
        recent: "Avis récents",
        empty: "Aucun avis pour le moment. Sois le premier !",
        anonymous: "Anonyme",
      },
      pdf: {
        generatedBy: "Généré par iDiag",
        generatedOn: "Généré le",
        page: "Page",
      },
    },
  },
  en: {
    translation: {
      app: { name: "iDiag", tagline: "iPhone Diagnostic" },
      nav: {
        install: "Install app",
        installed: "App installed",
        language: "Language",
        history: "History",
      },
      hero: {
        title: "Diagnose your iPhone in seconds",
        subtitle:
          "Upload a panic log file (.ips) and our expert-level AI identifies the faulty component, with deep technical analysis and repair steps.",
        badge: "AI analysis · Apple .ips",
      },
      gate: {
        title: "Before you start",
        subtitle: "Tell us your first name to continue.",
        label: "Your first name",
        placeholder: "Enter your first name",
        start: "Start the diagnosis",
        greeting: "Hello",
        change: "Change",
      },
      uploader: {
        drop: "Drop your .ips file here",
        or: "or",
        browse: "Choose file",
        formats: "Formats: .ips, .panic, .synapse, .crash, .log, .txt — max. 50 MB",
        analyzing: "Analyzing panic log…",
        analyzingHint: "The AI is examining the panic string, kernel, SoC and component chain.",
        analyzingLong: "This can take between 20 and 60 seconds.",
        errorTooBig: "File is too large (max. 50 MB).",
        errorEmpty: "File is empty.",
        errorGeneric: "Could not analyze the file.",
        offline: "Offline. Diagnosis requires an internet connection.",
        invalidType: "Unsupported file type.",
      },
      result: {
        title: "Diagnosis",
        device: "Device",
        cpu: "CPU",
        ios: "iOS",
        panicTag: "Panic tag",
        panicType: "Panic type",
        shortDescription: "Description",
        primary: "Primary faulty component",
        involved: "Involved components",
        confidence: "Confidence",
        technicalAnalysis: "Technical analysis",
        repairSteps: "Repair steps",
        stepObjective: "Objective",
        stepCommonFaults: "Common faults",
        stepProcedures: "Procedures",
        stepExpected: "Expected results",
        replacementOrder: "Recommended replacement order",
        postRepair: "Post-repair procedures",
        conclusion: "Technical conclusion",
        severity: "Severity",
        severityLow: "Low",
        severityMedium: "Medium",
        severityHigh: "High",
        severityCritical: "Critical",
        new: "New diagnosis",
        share: "Share",
        exportPdf: "Export PDF",
        exporting: "Generating PDF…",
        copied: "Copied to clipboard",
        savedAt: "Saved on",
      },
      history: {
        title: "Diagnostic history",
        subtitle: "The 50 most recent analyses.",
        empty: "No diagnostics yet.",
        backHome: "Back to home",
        loading: "Loading…",
        notFound: "Diagnostic not found.",
      },
      footer: {
        rights: "All rights reserved.",
      },
      reviews: {
        button: "Leave your review",
        title: "Leave your review",
        subtitle: "Tell us about your experience with iDiag.",
        rating: "Your rating",
        name: "Your name (optional)",
        comment: "Your comment",
        commentPlaceholder: "Write your review…",
        addPhoto: "Add a photo",
        changePhoto: "Change photo",
        submit: "Submit review",
        submitting: "Submitting…",
        success: "Thanks for your review!",
        error: "Could not submit your review.",
        ratingRequired: "Please select a rating.",
        commentRequired: "Please write a comment.",
        recent: "Recent reviews",
        empty: "No reviews yet. Be the first!",
        anonymous: "Anonymous",
      },
      pdf: {
        generatedBy: "Generated by iDiag",
        generatedOn: "Generated on",
        page: "Page",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "fr", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "idiag-lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
